// Shared theme helpers — System -> Light -> Dark cycle, same order and
// semantics as anyainow's theme control (see /var/www/anyainow/lib/theme.ts).
// The stored preference stays "system" until the user explicitly picks
// Light or Dark; "system" itself resolves to the OS preference at apply
// time via prefers-color-scheme.

export const THEME_ORDER = ["system", "light", "dark"];

export const THEME_LABEL = { system: "Auto", light: "Light", dark: "Dark" };

export function readTheme() {
  try {
    const t = localStorage.getItem("theme");
    if (t === "system" || t === "light" || t === "dark") return t;
  } catch {
    /* ignore unavailable storage */
  }
  return "system";
}

export function resolveTheme(theme) {
  if (theme === "system") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  }
  return theme;
}

export function applyTheme(theme) {
  document.documentElement.dataset.theme = resolveTheme(theme);
}

export function nextTheme(theme) {
  const i = THEME_ORDER.indexOf(theme);
  return THEME_ORDER[(i + 1) % THEME_ORDER.length];
}
